export default __webpack_public_path__ + "static/media/uploader-trivia-3.4372604e.png";